<template>
  <div>
    <v-row align="start">
      <v-col cols="12">
        <UserAddresses :showBack="true" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UserAddresses from "@/components/deliveryAddresses/UserAddresses.vue";

export default {
  components: {
    UserAddresses,
  },
};
</script>

<style lang="sass" scoped>
</style>